<template>
  <div>
    <navigation />
    <div class="editexam-container">
      <div class="titles">
        <p>测试题名:</p>
        <input type="text" v-model="examInfo.name" />
        <p>描述:</p>
        <input type="text" v-model="examInfo.desc" />
        <select v-model="examType">
          <option :value="1">练习题</option>
          <option :value="2">考试题</option>
          <option :value="3">应聘练习题</option>
          <option :value="4">应聘考试题</option>
        </select>
      </div>
      <div class="titles">
        <button class="hollow-btn" style="color: black; border:1px solid #5d89c0;" @click="modifyExamImages = true">
          修改考试图片
        </button>
        <el-cascader
          v-model="defaultClasses"
          :options="classOptions"
          :props="props"
          filterable
          collapse-tags
          clearable
          placeholder="请选择类别"
          ref="cascader"
          @change="handleClasses"
        ></el-cascader>
        <button @click="releaseExam()">发布</button>
      </div>
      <div class="imagelist">
        <div class="image-card" v-for="image of imageList" :key="image.id">
          <div class="image-content">
            <img :src="imageReformat(image.url)" @click="toImageDetail(image.id)" />
          </div>
          <div class="image-info">
            <span id="imageid">{{ image.id }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="请修改考试图片" :visible.sync="modifyExamImages">
      <textarea class="textarea-style" v-model="imageIds" placeholder="请输入imageids"></textarea>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modifyExamImages = false">取消</el-button>
        <el-button type="primary" @click="setImageIds()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '@/api/api.js';
import navigation from '@/components/navigation';
import { classificationObj } from '@/config';
import { imageReformat } from '@/utils/util';

export default {
  data() {
    return {
      imageIds: '',
      imageList: [],
      classifications: [],
      props: { multiple: true },
      classOptions: [
        {
          value: 1,
          label: 'knife类',
          children: [],
        },
        {
          value: 2,
          label: 'gf_k_l类',
          children: [],
        },
        {
          value: 3,
          label: '其他',
          children: [],
        },
      ],
      defaultClasses: [],
      selectedClassIdList: [],
      examInfo: {},
      examType: 1,
      modifyExamImages: false,
    };
  },
  components: {
    navigation,
  },
  mounted: function() {
    this.getImageList();
    this.getUserTotalClasses();
    this.getExamInfo();
  },
  methods: {
    imageReformat,
    toImageDetail(imageId) {
      this.$router.push({ path: `/image/${imageId}`, query: { f: 'exam', eid: this.$route.params.examid } });
      this.$store.commit('setAdminImageList', {
        imageList: this.imageList.map(v => {
          return {
            imageId: v.id,
          };
        }),
      });
    },
    getImageList() {
      api.getExamImageList(this.$route.params.examid).then(res => {
        this.imageList = res.data;
        window.console.log(this.imageList);
      });
    },
    addImages() {
      if (this.imageIds !== '') {
        let ids = this.imageIds
          .split(',')
          .map(v => parseInt(v))
          .filter(v => !isNaN(v));
        api.addImageToExam(this.$route.params.examid, { imageIds: ids }).then(() => {
          this.$notify({
            group: 'foo',
            type: 'custom-blue',
            text: `添加成功`,
            duration: 1500,
          });
          this.getImageList();
          // this.getExamInfo();
        });
      }
    },
    setImageIds() {
      const tmpExamImageIds = this.imageIds.split(',');
      const tmpExamImageIdsLength = tmpExamImageIds.length;
      const examImageIds = tmpExamImageIds.map(v => parseInt(v)).filter(v => !isNaN(v));
      const examImageIdsLength = examImageIds.length;
      if (tmpExamImageIdsLength !== examImageIdsLength) {
        this.$notify({
          group: 'foo',
          type: 'custom-red',
          text: `图片列表格式有误`,
          duration: 3000,
        });
      } else {
        this.modifyExamImages = false;
      }
    },
    releaseExam() {
      const examName = this.examInfo.name;
      const examDesc = this.examInfo.desc;
      const examImageIds = this.imageIds
        .split(',')
        .map(v => parseInt(v))
        .filter(v => !isNaN(v));
      const examType = this.examType;
      api
        .releaseExam(this.$route.params.examid, {
          name: examName,
          desc: examDesc,
          type: examType,
          imageIds: examImageIds,
          classIds: this.selectedClassIdList,
        })
        .then(() => {
          this.$notify({
            group: 'foo',
            type: 'custom-blue',
            text: `发布成功`,
            duration: 1500,
          });
        });
    },
    getUserTotalClasses() {
      api
        .getUserTotalClasses()
        .then(res => {
          this.classifications = res.data.classifications;
          this.reformatClassificationOptions();
        })
        .catch(() => {});
    },
    reformatClassificationOptions() {
      this.classifications.forEach(v => {
        v.classes.forEach(classInfo => {
          if (classificationObj['knife'].includes(classInfo.classId)) {
            this.classOptions[0].children.push({
              value: classInfo.classId,
              label: classInfo.className,
            });
          } else if (classificationObj['gf_k_l'].includes(classInfo.classId)) {
            this.classOptions[1].children.push({
              value: classInfo.classId,
              label: classInfo.className,
            });
          } else {
            this.classOptions[2].children.push({
              value: classInfo.classId,
              label: classInfo.className,
            });
          }
        });
      });
    },
    handleClasses(value) {
      this.selectedClassIdList = value.map(v => v[1]);
    },
    getExamInfo() {
      api.getExamInfo(this.$route.params.examid).then(res => {
        this.examInfo = res.data;
        this.examType = this.examInfo.type;
        this.imageIds = this.examInfo.imageIds.join(',');
        this.selectedClassIdList = this.examInfo.classIds || [];
        this.defaultClasses = [];
        (this.examInfo.classIds || []).forEach(v => {
          if (classificationObj['knife'].includes(v)) {
            this.defaultClasses.push([1, v]);
          } else if (classificationObj['gf_k_l'].includes(v)) {
            this.defaultClasses.push([2, v]);
          } else {
            this.defaultClasses.push([3, v]);
          }
        });
      });
    },
  },
};
</script>
<style scoped>
.editexam-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 50px 50px 1fr;
  gap: 20px;
  min-height: 100vh;
}
.titles {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
}
.titles p,
.titles input,
.titles select {
  margin: 0;
  height: 32px; /* 统一高度 */
  display: inline-flex;
  align-items: center; /* 内容垂直居中 */
  font-size: 16px;
}
.titles input {
  box-sizing: border-box;
  border: 1px solid #dddddd;
  border-radius: 4px;
  padding: 0px 12px;
  margin-right: 40px;
}
button {
  height: 32px;
  border: none;
  margin: 0px 12px;
}
.imagelist {
  min-height: 0;
  height: 100%;
  text-align: left;
  margin-top: 22px;
}
.image-card {
  display: inline-block;
  margin: 0px;
  margin-bottom: 12px;
  padding: 0px;
  text-align: center;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  vertical-align: top;
  width: 245px;
}
.delete-button {
  display: none;
  background: #c05d5d;
  margin-top: 4px;
}
.image-card:hover .delete-button {
  display: inline-block;
}
.image-info {
  height: 36px;
  position: relative;
}
.image-content {
  height: 150px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
}
img {
  max-height: 150px;
  max-width: 243px;
  cursor: pointer;
  margin: auto;
}
#imageid {
  bottom: 10px;
  left: 12px;
  position: absolute;
  font-size: 14px;
}
#imagestatus {
  position: absolute;
  bottom: 10px;
  right: 12px;
  font-size: 14px;
}
.textarea-style {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  font-size: 16px;
  resize: none;
  min-height: 300px;
}
</style>
